import Icon from "./IconBase.js";
const LectureScheduledIcon = (props) => {
  return (
    <Icon width="36" height="36" viewBox="0 0 36 36" {...props}>
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 0C15.6362 0 13.2956 0.465584 11.1117 1.37017C8.92784 2.27475 6.94353 3.60062 5.27208 5.27208C1.89642 8.64773 0 13.2261 0 18C0 22.7739 1.89642 27.3523 5.27208 30.7279C6.94353 32.3994 8.92784 33.7252 11.1117 34.6298C13.2956 35.5344 15.6362 36 18 36C22.7739 36 27.3523 34.1036 30.7279 30.7279C34.1036 27.3523 36 22.7739 36 18C36 15.6362 35.5344 13.2956 34.6298 11.1117C33.7252 8.92784 32.3994 6.94353 30.7279 5.27208C29.0565 3.60062 27.0722 2.27475 24.8883 1.37017C22.7044 0.465584 20.3638 0 18 0Z"
          fill="#F0ECFC"
        />
        <path
          d="M14.7197 13.8265L21.7789 13.8265"
          stroke="#6E42E5"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7197 17.9197L21.7789 17.9197"
          stroke="#6E42E5"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0852 22.0035L21.7788 22.0035"
          stroke="#6E42E5"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5316 27C14.5316 27 22.0376 26.9961 22.0494 26.9961C24.7479 26.9795 26.4188 25.2039 26.4188 22.4956L26.4188 13.5044C26.4188 10.7824 24.7352 9 22.0132 9C22.0132 9 14.5081 9.00293 14.4954 9.00293C11.7969 9.01956 10.125 10.7961 10.125 13.5044L10.125 22.4956C10.125 25.2176 11.8096 27 14.5316 27Z"
          stroke="#6E42E5"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default LectureScheduledIcon;
